import React from 'react';
import FAQsPage from './Page.tsx';
import PageFade from '@/common/components/PageFade.tsx';

const FAQsRoute: React.FC = () => {
  return (
    <PageFade>
      <FAQsPage />
    </PageFade>
  );
};

export default FAQsRoute;
